var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "grid grid-cols-2 grid-flow-row md:table-row" },
    [
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Subscriber ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-2 md:px-2 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.getCustomerName(_vm.subscriber)) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Browser ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.subscriber.browser) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" OS ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.subscriber.os) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Device Used ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
        },
        [_vm._v(" " + _vm._s(_vm.subscriber.deviceUsed) + " ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
        },
        [_vm._v(" Date ")]
      ),
      _c(
        "td",
        {
          staticClass:
            "px-1 md:px-1 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
        },
        [
          _vm._v(
            " " + _vm._s(_vm._f("dateFilter")(_vm.subscriber.createdAt)) + " "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }